import React, { Fragment } from "react"
import Skeleton from "shared/Skeleton";

export const InventoryItemsSkeleton = () => {
  return (
    <div className="inventory-skeleton">
      <Skeleton width="64px" height="21px" borderRadius="40px" marginBottom="16px"/>
      {[...Array(3)].map((_, i) => (
        <div key={i} className="inventory-skeleton-row">
          <div className="inventory-skeleton-row__left">
            <Skeleton width="80%" height="21px" borderRadius="40px" />
            <Skeleton width="35%" height="12px" borderRadius="40px" />
          </div>
          <Skeleton width="111px" height="39px" borderRadius="40px" />
        </div>
      ))}
      <Skeleton width="100%" height="60px" borderRadius="40px" className="inventory-skeleton-btn" />
    </div>
  );
}
